export default {
    cancel: '取消',
    ok: '確定',
}